module.exports = __webpack_public_path__ + "static/media/Video.9e2e6b30.svg";